"use strict";

exports.__esModule = true;
var _DragDropContextProvider = require("./DragDropContextProvider");
Object.keys(_DragDropContextProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DragDropContextProvider[key]) return;
  exports[key] = _DragDropContextProvider[key];
});